import type { TranslationDict } from '../en';

const ga: TranslationDict = {
  'header.buy': 'Ceannaigh',
  'header.sell': 'Díol',
  'spend.label': 'Caiteachas',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'A fhaigheann tú',
  'payment.label': 'Modh íocaíochta',
  'payment.select': 'Roghnaigh',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Níl aon mhodh íocaíochta ar fáil don phéire seo',
  'wallet.label': 'Seoladh sparáin glactha',
  'wallet.placeholderBuy': 'Iontráil do sheoladh glactha',
  'wallet.placeholderSell': 'Iontráil do sheoladh seolta',
  'wallet.validating': 'Ag fíorú an tseolta...',
  'wallet.invalid': 'Iontráil seoladh sparáin bailí',
  'wallet.invalidServer': 'Seoladh sparáin neamhbhailí',
  'cta.buy': 'Ceannaigh {crypto}',
  'cta.sell': 'Díol {crypto}',
  'cta.gettingPrice': 'Ag lorg an phraghais is fearr...',
  'cta.processing': 'Ag próiseáil...',
  'footer.poweredBy': 'Powered by ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Miondealú an ráta',
  'rate.close': 'Dún',
  'rate.updatesIn': 'Nuashonraítear an ráta i 00:{seconds}',
  'rate.noQuote': 'Níl aon luachan ar fáil',
  'rate.exchangeRate': 'Ráta malairte',
  'rate.processingFee': 'Táille próiseála',
  'rate.networkFee': 'Táille líonra',
  'rate.provider': 'Soláthraí',
  'toast.orderCreated': 'Ordú cruthaithe',
  'toast.redirecting': 'Ag atreorú chuig an seiceáil amach...',
  'toast.orderFailed': 'Theip ar an ordú',
  'toast.couldNotCreate': 'Níorbh fhéidir an t-ordú a chruthú',
  'toast.quoteError': 'Earráid luachana',
  'toast.noProviders': 'Níl aon soláthraí ar fáil',
  'toast.somethingWrong': 'Chuaigh rud éigin mícheart',
  'error.amountZero': 'Ní mór don mhéid a bheith níos mó ná 0',
  'error.minAmountFiat': 'Is é {min} {currency} an méid íosta',
  'error.minAmountCrypto': 'Is é {min} {currency} an méid íosta',
  'error.noProviders': 'Níl aon soláthraí ar fáil don chomhcheangal seo',
  'error.currencyUnavailableBuy': 'Níl an airgeadra seo ar fáil le haghaidh orduithe ceannaigh',
  'error.currencyUnavailableSell': 'Níl an airgeadra seo ar fáil le haghaidh orduithe díolta',
  'parity.info': 'Gearrfar {receiveAmount} {crypto} ort, agus creidmheasfar an chuid eile suas go {spendAmount} {fiat} chuig do chuntas {partner}',
  'redirect.secureBadge': 'Íocaíocht slán',
  'redirect.title': 'Lean ar aghaidh leis an íocaíocht',
  'redirect.description': 'Atreorófar thú chuig {gateway} chun d\'íocaíocht a chríochnú.',
  'redirect.countdown': 'Ag atreorú i {seconds}...',
  'redirect.openTab': 'Oscail ACH i gcluaisín nua',
  'redirect.cancel': 'Cealaigh',
  'checkout.noOrder': 'Níor aimsíodh aon ordú',
  'checkout.goBack': 'Téigh ar ais',
  'checkout.expired': 'Tháinig deireadh leis an seiceáil amach',
  'checkout.expiredDesc': 'Tháinig deireadh leis an seisiún. Bain triail as arís le do thoil.',
  'checkout.startOver': 'Tosaigh arís',
  'checkout.cancel': 'Cealaigh',
  'checkout.loading': 'Ag lódáil seiceáil amach...',
  'checkout.iframeTitle': 'Seiceáil amach an tSoláthraí',
  'checkout.widgetTitle': 'Seiceáil amach íocaíochta',
  'checkout.unknownMethod': 'Modh seiceála amach anaithnid',
  'processing.default': 'Ag próiseáil do ordú...',
  'processing.pending': 'Ag fanacht le deimhniú íocaíochta...',
  'processing.active': 'Ag próiseáil do idirbheart...',
  'processing.generic': 'Ag próiseáil...',
  'processing.checkingStatus': 'Ag seiceáil stádas...',
  'processing.orderId': 'Aitheantóir ordaithe',
  'processing.provider': 'Soláthraí',
  'processing.amount': 'Méid',
  'processing.receiving': 'Á ghlacadh',
  'processing.network': 'Líonra',
  'processing.toAddress': 'Chuig seoladh',
  'processing.usuallyMinutes': 'De ghnáth tógann sé cúpla nóiméad.',
  'processing.safeToClose': 'Is féidir leat an leathanach seo a dhúnadh go sábháilte – seolfaimid ríomhphost chugat nuair a bheidh sé críochnaithe.',
  'complete.buyTitle': 'Ceannach Críochnaithe!',
  'complete.sellTitle': 'Díol Críochnaithe!',
  'complete.buyDesc': 'Seoladh do {crypto} chuig do sparán.',
  'complete.sellDesc': 'Tá do íocaíocht {fiat} á próiseáil.',
  'complete.amountBuy': 'Méid Faighte',
  'complete.amountSell': 'Méid Díolta',
  'complete.paidBuy': 'Méid Íoctha',
  'complete.paidSell': 'Méid Íocaíochta',
  'complete.network': 'Líonra',
  'complete.wallet': 'Sparán',
  'complete.transaction': 'Idirbheart',
  'complete.provider': 'Soláthraí',
  'complete.orderId': 'Aitheantóir ordaithe',
  'complete.completed': 'Críochnaithe',
  'complete.viewExplorer': 'Féach ar an taiscéalaí',
  'complete.done': 'Déanta',
  'errorStep.failed': 'Theip ar an íocaíocht',
  'errorStep.cancelled': 'Ordú curtha ar ceal',
  'errorStep.expired': 'Tháinig deireadh leis an ordú',
  'errorStep.refunded': 'Ordú aisíoctha',
  'errorStep.unknown': 'Chuaigh rud éigin mícheart',
  'errorStep.failedBuy': 'Níorbh fhéidir d\'íocaíocht a phróiseáil. Bain triail as arís nó úsáid modh íocaíochta difriúil.',
  'errorStep.failedSell': 'Níorbh fhéidir do dhíol a phróiseáil. Bain triail as arís le do thoil.',
  'errorStep.cancelledBuy': 'Cuireadh do ordú ar ceal. Níor próiseáladh aon íocaíocht.',
  'errorStep.cancelledSell': 'Cuireadh do dhíol ar ceal. Níor aistríodh aon cripteaitheas.',
  'errorStep.expiredBuy': 'Tháinig deireadh le do ordú. Tosaigh ceannach nua le do thoil.',
  'errorStep.expiredSell': 'Tháinig deireadh le do ordú. Tosaigh díol nua le do thoil.',
  'errorStep.refundedBuy': 'Aisíocadh d\'íocaíocht. Ba cheart go mbeadh na cistí le feiceáil i do chuntas laistigh de 5-10 lá gnó.',
  'errorStep.refundedSell': 'Cuireadh do chripteaitheas ar ais. Ba cheart go mbeadh na cistí le feiceáil i do sparán go luath.',
  'errorStep.genericDesc': 'Tharla earráid gan choinne. Bain triail as arís le do thoil.',
  'errorStep.orderId': 'Aitheantóir ordaithe',
  'errorStep.tryAgain': 'Bain triail arís',
  'errorStep.startOver': 'Tosaigh arís',
  'errorStep.return': 'Ar ais',
  'errorStep.needHelp': 'Cabhair uait? Déan teagmháil le ',
  'errorStep.reference': 'Tagairt: {orderId}',
  'confirm.buyTitle': 'Deimhnigh an ceannach',
  'confirm.sellTitle': 'Deimhnigh an díol',
  'confirm.loading': 'Ag lódáil...',
  'confirm.provider': 'Soláthraí',
  'confirm.youPay': 'Íocann tú',
  'confirm.youSell': 'Díolann tú',
  'confirm.youReceive': 'Faigheann tú',
  'confirm.wallet': 'Sparán',
  'confirm.network': 'Líonra',
  'confirm.refundAddress': 'Seoladh aisíoca',
  'confirm.parityNote': 'D\'fhéadfadh an méid a ghearrtar ón soláthraí a bheith difriúil. Creidmheasfar an chuid eile suas go {amount} {crypto} chuig do chuntas {partner}.',
  'confirm.processing': 'Ag próiseáil...',
  'confirm.confirmPay': 'Deimhnigh agus Íoc',
  'confirm.confirmSell': 'Deimhnigh agus Díol',
  'confirm.payout': 'Íocaíocht {currency}',
  'modal.selectFiat': 'Roghnaigh airgeadra fiat',
  'modal.selectCrypto': 'Roghnaigh cripteaitheas',
  'modal.choosePayment': 'Roghnaigh modh íocaíochta',
  'modal.selectCountry': 'Roghnaigh do thír',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Coitianta',
  'modal.recommended': 'Molta',
  'modal.noCurrencies': 'Níor aimsíodh aon airgeadra',
  'modal.noPaymentMethods': 'Níor aimsíodh aon mhodh íocaíochta',
  'modal.noCountries': 'Níor aimsíodh aon tír',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Suíomh',
  'settings.darkMode': 'Mód dorcha',
  'settings.privacy': 'Polasaí príobháideachta',
  'settings.terms': 'Téarmaí úsáide',
  'settings.language': 'Teanga',
  // ─── Additional ───
  'modal.chooseRamp': 'Roghnaigh Ramp',
  'modal.bestPrice': 'An praghas is fearr',
  'modal.noQuotes': 'Níl aon luachan ar fáil don iarratas seo',
  'modal.noProvidersFound': 'Níor aimsíodh aon soláthraí',
  'payment.unavailableFor': 'Níl aon mhodh íocaíochta ar fáil do {currency}',
  'skeleton.poweredBy': 'Powered by NowRamp',
  'error.createOrderFailed': 'Theip ar chruthú an ordaithe',
  'errorStep.returnToMerchant': 'Fill ar an gceannaí',
  'confirm.cryptoOnNetwork': '{crypto} ar {network}',
  'payment.name.card': 'Cárta',
  'payment.name.bankTransfer': 'Aistriú Banc',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default ga;
